import React, { useState, useEffect, Fragment } from 'react';
import Loader from '../../Common/Loader';
import moment from 'moment-timezone';
import axios from 'axios';
import Filter from './Filter';
import ErrorTablePopup from './ErrorTablePopup';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import constants from '../../../constants';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const ChannelsLogWrapper = () => {
  const [list, setList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [ota, setOta] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [categoHide, setCategoHide] = useState(true);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const [searchParam, setSearchParam] = useState({
    hotelId: '',
    channelId: 0,
    status: 'all',
    requestType: 'all',
    searchBy: 'requested_date',
    fromDate: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    toDate: moment(new Date()).format('YYYY-MM-DD'),
    pmsCategoryId: ''
  });

  useEffect(() => {
    getOTAList();
    searchLogs();
    // eslint-disable-next-line
  }, [pageNumber]);

  const setMessageFunc = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => setFlag(false), 3000);
  };

  const searchLogs = () => {
    setShowUILoader(true);
    setList([]);
    setTotal(0);
    axios(serverUrl + 'logs/getchannellogs', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        page: pageNumber,
        limit: limit,
        searchParam: searchParam
      }
    }).then(response => {
      if (response.data.status === 'success') {
        setList(response.data.data.otaActivityLogs);
        setTotal(response.data.data.resCount);
      } else {
        setMessageFunc('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const renderLogsList = () => {
    return Object.keys(list).map(id => {
      var data = list[id];
      return (
        <div className="table_row border_t_1 border_color_1" key={id}>
          <div className="tabcel align_middle pad10">{data.channelName}</div>
          <div className="tabcel align_middle pad10">{data.hotelName}</div>
          <div className="tabcel align_middle pad10">{data.request_type}</div>
          <div className="tabcel align_middle pad10">{data.category_name}</div>
          <div className="tabcel align_middle pad10">{data.rate_plan_name}</div>
          <div className="tabcel align_middle pad10">{data.start_date}</div>
          <div className="tabcel align_middle pad10">{data.end_date}</div>
          <div className="tabcel align_middle pad10">
            { data.status !== 'success'
              ? <a
                className="inline align_middle"
                href="#"
                title="Errors"
                onClick={() => toggleErrorPopup(true, data.error_reason)}
              >
                {data.status}
              </a>
              : <Fragment>
                <i className="fa fa-check-circle green-color"></i>
                {` ${data.status}`}
              </Fragment>}
            { typeof data.timeAndDate !== 'undefined' && <span className="pull-left txt-grey12 mar-top8">{data.timeAndDate}</span>}
          </div>
        </div>
      );
    });
  };

  const toggleErrorPopup = (val, errors) => {
    setShowPopup(val);
    setErrorList(errors);
  };

  const handlePageChange = pageNumber => {
    var counter = pageNumber <= 1 ? 0 : (pageNumber - 1) * limit;
    setPageNumber(pageNumber);
    setCounter(counter);
    // searchLogs will be called by useEffect
  };

  const dateChange = (date, type) => {
    const newDate = moment(date).format('YYYY-MM-DD');
    setSearchParam(prev => ({ ...prev, [type]: newDate }));
  };

  const getOTAList = () => {
    axios(serverUrl + 'common/getotalist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    }).then(response => {
      if (response.status === 200) {
        setOta(response.data);
      } else {
        setMessageFunc('error', response.data.message);
      }
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const paramChange = (e, type) => {
    setSearchParam(prev => {
      const newSearch = { ...prev };
      if (type === 'hotelName') {
        newSearch[type] = e.length > 0 ? e[0].hotel : '';
        newSearch['hotelId'] = e.length > 0 ? e[0].hotel_id : '';
      } else {
        newSearch[type] = e.target.value;
      }
      return newSearch;
    });
  };

  const typeheadInputChange = (selected, type) => {
    if (type === 'hotelName') {
      let newSearch = [...categoryList];
      if (newSearch.length > 0 && searchParam.hotelId === '') {
        newSearch = [];
        setCategoryList(newSearch);
      }
    }
  };

  const getCategoryList = (hotel) => {
    setShowUILoader(true);
    axios(serverUrl + 'log/categorylist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { page: 1, limit: 50, hotelName: hotel } }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setCategoryList(response.data.data);
          setCategoHide(false);
        } else {
          setMessageFunc('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const setOtaDetails = (channelIds) => {
    setSearchParam(prev => ({ ...prev, channelId: channelIds }));
  };

  const reset = () => {
    setSearchParam({
      hotelId: '',
      channelId: 0,
      status: 'all',
      requestType: 'all',
      searchBy: 'requested_date',
      fromDate: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
      toDate: moment(new Date()).format('YYYY-MM-DD'),
      pmsCategoryId: ''
    });
    setPageNumber(1);
    setCounter(0);
    setList([]);
    setTotal(0);
    searchLogs();
  };

  return (
    <Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Channel Logs</div>
          </div>
        </div>
      </div>
      {flag
        ? <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div> : ''}
      <Filter
        params={searchParam}
        dateChange={dateChange}
        paramChange={paramChange}
        searchLogs={searchLogs}
        ota={ota}
        reset={reset}
        categoryList={categoryList}
        categoHide={categoHide}
        typeheadInputChange={typeheadInputChange}
      />
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Channel</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Hotel Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Update Type</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Room Category</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Rate Plan</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Start Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">End Date</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Status</div>
              </div>
              {renderLogsList()}
            </div>
          </div>
          {total === 0 && !showUILoader
            ? <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Logs Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No Logs Found</div>
            </div> : ''}
        </div>
        {total > limit
          ? <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={pageRangeDisplayed}
              onChange={handlePageChange}
            /> */}
          </div> : ''}
      </div>
      {showPopup &&
        <ErrorTablePopup
          errorList={errorList}
          toggleErrorPopup={toggleErrorPopup}
        />
      }
    </Fragment>
  );
};

export default ChannelsLogWrapper;
